import script from "./folder.vue?vue&type=script&lang=js"
export * from "./folder.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"resources/js/pages/layouts/partials/sidebar/folder.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "cdbc6d82"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('cdbc6d82', __exports__)) {
    console.log('reload')
    api.reload('cdbc6d82', __exports__)
  }
  
}


export default __exports__